import * as R from 'ramda'
import { DateFormat, DateUtils, moment } from '@pbt/pbt-ui-components'

import i18n from '~/locales/i18n'
import { isToday, isTomorrow, isYesterday } from '~/utils/time'

export const formatWidgetDate = (widgetDate: string, withSuffix = false) =>
  R.cond([
    [R.isNil, R.always(null)],
    [
      isYesterday,
      R.always(
        withSuffix
          ? `${i18n.t('Time:LABEL.YESTERDAY')} ${DateUtils.formatTime(
              widgetDate,
            )}`
          : i18n.t('Time:LABEL.YESTERDAY'),
      ),
    ],
    [
      isToday,
      R.always(
        withSuffix
          ? `${i18n.t('Time:LABEL.TODAY')} ${DateUtils.formatTime(widgetDate)}`
          : i18n.t('Time:LABEL.TODAY'),
      ),
    ],
    [
      isTomorrow,
      R.always(
        withSuffix
          ? `${i18n.t('Time:LABEL.TOMORROW')} ${DateUtils.formatTime(
              widgetDate,
            )}`
          : i18n.t('Time:LABEL.TOMORROW'),
      ),
    ],
    [
      R.T,
      (date: string) =>
        moment(date).format(DateFormat.DAY_OF_WEEK_ABBREV_COMMA_MONTH_DAY),
    ],
  ])(widgetDate)
